export const showDisclaimer = 'showDisclaimer'
